export default __webpack_public_path__ + "static/media/mi1.be9b6d37.jpg";